module.exports = function (worker, handler) {
  worker.onmessage = function (_ref) {
    var data = _ref.data;
    // eslint-disable-line
    handler(data);
  };
};